export const ActionTypes = {
  SHOW_EDIT_HINT: 'harami/templates/SHOW_EDIT_HINT',
  CLOSE_EDIT_HINT: 'harami/templates/CLOSE_EDIT_HINT',
} as const satisfies { [k: string]: string }
